import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "analytics-notes-trade-tab-switcher" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RedesignedSwitchComponent = _resolveComponent("RedesignedSwitchComponent")!
  const _component_AnalyticsNotesStructureExportTable = _resolveComponent("AnalyticsNotesStructureExportTable")!
  const _component_AnalyticsNotesProductsExportTable = _resolveComponent("AnalyticsNotesProductsExportTable")!
  const _component_AnalyticsNotesStructureImportTable = _resolveComponent("AnalyticsNotesStructureImportTable")!
  const _component_AnalyticsNotesProductsImportTable = _resolveComponent("AnalyticsNotesProductsImportTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_RedesignedSwitchComponent, {
      class: "analytics-notes-trade-tab-switcher__switch",
      checked: _ctx.isExport,
      textTrue: "Экспорт",
      textFalse: "Импорт",
      onSwitchHandler: _ctx.switchHandler,
      mode: "line"
    }, null, 8, ["checked", "onSwitchHandler"]),
    _createElementVNode("div", {
      class: _normalizeClass(["analytics-notes-trade-tab-switcher__tab", { 'analytics-notes-trade-tab-switcher__tab--hidden': !_ctx.isExport }])
    }, [
      _createVNode(_component_AnalyticsNotesStructureExportTable, {
        filter: _ctx.filter,
        isMonthly: _ctx.isMonthly
      }, null, 8, ["filter", "isMonthly"]),
      _createVNode(_component_AnalyticsNotesProductsExportTable, {
        filter: _ctx.filter,
        isMonthly: _ctx.isMonthly
      }, null, 8, ["filter", "isMonthly"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["analytics-notes-trade-tab-switcher__tab", { 'analytics-notes-trade-tab-switcher__tab--hidden': _ctx.isExport }])
    }, [
      _createVNode(_component_AnalyticsNotesStructureImportTable, {
        filter: _ctx.filter,
        isMonthly: _ctx.isMonthly
      }, null, 8, ["filter", "isMonthly"]),
      _createVNode(_component_AnalyticsNotesProductsImportTable, {
        filter: _ctx.filter,
        isMonthly: _ctx.isMonthly
      }, null, 8, ["filter", "isMonthly"])
    ], 2)
  ]))
}